// import { useCurrentUser } from "../hooks/contexts/currentUserContext"
import { logOut } from '../../firebase/authenticationApi'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import RouteButton from '../../assets/components/RouteButton'
import { ROUTES } from '../../utils/api'
import BasicButton from '../../assets/components/BasicButton'
import { Piano, AccountCircleOutlined, LogoutOutlined, LoyaltyOutlined, HelpOutline, AdminPanelSettingsOutlined, HexagonSharp } from '@mui/icons-material'
import { useEffect } from 'react'
import Account from './Components/Account'
import License from './Components/License'
import About from '../About'
import MenuWithContent from '../../assets/components/MenuWithContent'
import { useChangeCurrentLocation } from '../../hooks/contexts/currentLocationContext'
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen'
import { Box, Container, Divider } from '@mui/material'
import { useCurrentUser } from '../../hooks/contexts/currentUserContext'

import { useContext } from 'react'
import { PolyglotContext } from '../../polyglot/polyGlotContext'
import Instruments from './Components/Instruments'

const Settings = () => {
    const { polyglot } = useContext(PolyglotContext)

    const currentUser = useCurrentUser()
    const navigate = useNavigate()
    const curPath = useLocation().pathname
    const isSmallScreen = useIsSmallScreen()

    const changeCurrentLocation = useChangeCurrentLocation()

    useEffect(() => {
        if (curPath === ROUTES.SETTINGS.MAIN) {
            // Default subpage in settings page
            navigate(ROUTES.SETTINGS.ACCOUNT.fullPath, { replace: true })
        }
    }, [curPath])

    useEffect(() => {
        changeCurrentLocation('Inställningar')
    }, [changeCurrentLocation])

    const generalRoutes = (
        <>
            <RouteButton title={polyglot.t('settings.accountRouteBtn')} route={ROUTES.SETTINGS.ACCOUNT.fullPath} icon={AccountCircleOutlined} />
            {/* <RouteButton title={polyglot.t('settings.licenseRouteBtn')} route={ROUTES.SETTINGS.LICENSE.fullPath} icon={LoyaltyOutlined} /> */}
            <RouteButton title={polyglot.t('Instrument')} route={ROUTES.SETTINGS.INSTRUMENTS.fullPath} icon={Piano} />
            <RouteButton title={polyglot.t('settings.aboutRouteBtn')} route={ROUTES.SETTINGS.ABOUT.fullPath} icon={HelpOutline} />
            {/* icon (HexagonSharp) is temporary placeholder */}
            {/* {currentUser?.admin && <RouteButton title="Utvärdering" route={ROUTES.SETTINGS.EVALUATION.fullPath} icon={HexagonSharp}></RouteButton>} */}
        </>
    )

    return (
        <MenuWithContent
            showCurrentlyPlaying
            extraPadding
            menuItems={
                isSmallScreen && (
                    <>
                        {generalRoutes}
                        {currentUser?.admin && <RouteButton inHeader route={ROUTES.ADMIN.MAIN} title="Admin" icon={AdminPanelSettingsOutlined} />}
                    </>
                )
            }
            content={
                <Container
                    sx={{
                        paddingTop: isSmallScreen ? 1 : 3,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '50vh'
                    }}
                >
                    {!isSmallScreen && (
                        <>
                            <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'row' }}>
                                {generalRoutes}
                                {currentUser?.admin && <RouteButton inHeader route={ROUTES.ADMIN.MAIN} title={polyglot.t('settings.adminRouteBtn')} icon={AdminPanelSettingsOutlined} />}
                                <BasicButton title={polyglot.t('settings.logoutBtn')} onClick={logOut} icon={LogoutOutlined} color="primary" />
                            </Box>
                            <Divider orientation="horizontal" sx={{ borderColor: '#808080', my: 2 }} />
                        </>
                    )}

                    <Routes>
                        <Route path={ROUTES.SETTINGS.MAIN} element={<Navigate to={ROUTES.SETTINGS.ACCOUNT.fullPath} replace />} />
                        <Route path={ROUTES.SETTINGS.ACCOUNT.subPath} element={<Account />} />
                        <Route path={ROUTES.SETTINGS.ABOUT.subPath} element={<About />} />
                        <Route path={ROUTES.SETTINGS.LICENSE.subPath} element={<License />} />
                        <Route path={ROUTES.SETTINGS.INSTRUMENTS.subPath} element={<Instruments />} />
                        {/* {currentUser?.admin && <Route path={ROUTES.SETTINGS.EVALUATION.subPath} element={<Evaluation />} />} */}
                    </Routes>
                </Container>
            }
        />
    )
}

export default Settings
